import React, { useState } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { palette } from './ticketTheme';
import { TICKET_TERMS_SUMMARY } from './ticketTermsContent';
import TicketTermsModal from './TicketTermsModal';

const TicketTermsFooter = ({ sx = {} }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          textAlign: 'center',
          mt: 4,
          pt: 2,
          ...sx,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: palette.textMuted,
            fontWeight: 300,
            fontSize: 12,
            lineHeight: 1.7,
            display: 'block',
          }}
        >
          {TICKET_TERMS_SUMMARY}{' '}
          <Link
            component="button"
            type="button"
            onClick={() => setOpen(true)}
            sx={{
              color: palette.textSecondary,
              fontWeight: 400,
              fontSize: 'inherit',
              textDecoration: 'underline',
              textDecorationColor: palette.borderStrong,
              cursor: 'pointer',
              verticalAlign: 'baseline',
              '&:hover': { color: palette.accent },
            }}
          >
            Terms &amp; Conditions
          </Link>
        </Typography>
      </Box>

      <TicketTermsModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default TicketTermsFooter;
